var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSequence(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.94 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 14") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.94,
    width: 15.06,
    height: 2.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.94,
    y: 4.71,
    width: 6.59,
    height: 1.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 9.41,
    y: 4.71,
    width: 6.59,
    height: 1.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.94,
    y: 8.47,
    width: 6.59,
    height: 1.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 9.41,
    y: 8.47,
    width: 6.59,
    height: 1.88
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.82,12.94v2.35H.71V12.94H6.82m.71-.71H0V16H7.53V12.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.24,12.94v2.35H10.12V12.94h6.12m.71-.71H9.41V16h7.53V12.24Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSequence);
export default __webpack_public_path__ + "static/media/icon-sequence.6c89dec4fa3d6b0a0b38861be58545ea.svg";
export { ForwardRef as ReactComponent };